import React, { useEffect, useState } from "react";
import { api, brl } from "../lib/api";
import { toast } from "sonner";
import { Target, Coins } from "@phosphor-icons/react";
import BRLInput from "./BRLInput";

export default function GoalCofrinho() {
  const [progress, setProgress] = useState(null);
  const [edit, setEdit] = useState(false);
  const [income, setIncome] = useState(0);
  const [commission, setCommission] = useState(20);

  const load = async () => setProgress((await api.get("/gamification/me/goal-progress")).data);
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.post("/gamification/me/goal", {
        target_income: Number(income),
        commission_rate: Number(commission) / 100,
      });
      toast.success("Meta salva! Vamos bater juntas?");
      setEdit(false);
      load();
    } catch { toast.error("Erro ao salvar"); }
  };

  if (!progress) return null;

  if (!progress.goal && !edit) {
    return (
      <div className="border border-[#EBE5DF] bg-[#F5F0EB] p-6" data-testid="cofrinho-empty">
        <div className="flex items-center gap-2 mb-3">
          <Target size={20} weight="duotone" />
          <h2 className="section-title text-xl">Cofrinho de Metas</h2>
        </div>
        <p className="text-sm text-[#5C5A57] mb-4">Defina quanto quer ganhar este mes — a gente calcula quanto voce precisa vender por dia.</p>
        <button onClick={() => setEdit(true)} className="brand" data-testid="set-goal-btn">Definir meta</button>
      </div>
    );
  }

  if (edit) {
    return (
      <div className="border border-[#0A0A0A] bg-white p-6" data-testid="cofrinho-edit">
        <div className="flex items-center gap-2 mb-4">
          <Target size={20} weight="duotone" />
          <h2 className="section-title text-xl">Definir meta do mes</h2>
        </div>
        <div className="space-y-4">
          <div>
            <label className="block text-[10px] tracking-widest uppercase text-[#5C5A57] mb-1">Quanto quero ganhar</label>
            <BRLInput value={income} onChange={setIncome} testid="goal-income-input" />
          </div>
          <div>
            <label className="block text-[10px] tracking-widest uppercase text-[#5C5A57] mb-1">Minha comissao (% — informe inteiro, ex: 20 para 20%)</label>
            <input type="number" min="1" max="100" step="1" value={commission} onChange={(e) => setCommission(e.target.value)} className="input-underline tabular" placeholder="20" data-testid="goal-commission-input" />
          </div>
          {income > 0 && commission > 0 && (
            <div className="text-xs text-[#5C5A57] pt-2 border-t border-[#EBE5DF]">
              Para ganhar <strong>{brl(income)}</strong> com {commission}% de comissao voce precisa vender <strong className="tabular">{brl(Number(income) / (Number(commission) / 100))}</strong>.
            </div>
          )}
          <div className="flex justify-end gap-3 pt-3">
            <button onClick={() => setEdit(false)} className="text-xs tracking-widest uppercase text-[#5C5A57] hover:underline">Cancelar</button>
            <button onClick={save} className="brand" data-testid="save-goal-btn">Salvar meta</button>
          </div>
        </div>
      </div>
    );
  }

  const g = progress.goal;
  return (
    <div className="border border-[#EBE5DF] bg-white p-6" data-testid="cofrinho-active">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Target size={20} weight="duotone" />
          <h2 className="section-title text-xl">Meta do mes</h2>
        </div>
        <button onClick={() => { setEdit(true); setIncome(g.target_income); setCommission(g.commission_rate * 100); }} className="text-[10px] tracking-widest uppercase text-[#5C5A57] hover:text-black hover:underline" data-testid="edit-goal-btn">Editar</button>
      </div>

      <div className="flex items-baseline gap-2 mb-1">
        <Coins size={20} weight="duotone" />
        <span className="font-display text-3xl font-bold tracking-tight tabular">{brl(progress.earned_so_far)}</span>
        <span className="text-sm text-[#5C5A57]">/ {brl(g.target_income)}</span>
      </div>
      <div className="text-xs text-[#5C5A57] mb-4">Ja faturados (com {Math.round(g.commission_rate * 100)}% comissao)</div>

      <div className="h-3 bg-[#F5F0EB] overflow-hidden mb-1">
        <div
          className="h-full transition-all"
          style={{
            width: `${progress.progress_pct}%`,
            background: progress.progress_pct >= 100 ? "#7B9D7E" : "#0A0A0A",
          }}
          data-testid="progress-bar"
        />
      </div>
      <div className="flex justify-between text-[10px] tracking-widest uppercase text-[#5C5A57] mb-5">
        <span>{progress.progress_pct}%</span>
        <span>Faltam {progress.days_left} dia(s)</span>
      </div>

      <div className="grid grid-cols-3 gap-3 pt-4 border-t border-[#EBE5DF]">
        <div>
          <div className="text-[10px] tracking-widest uppercase text-[#5C5A57]">Vendido</div>
          <div className="font-display text-lg font-bold tabular">{brl(progress.sold_month)}</div>
        </div>
        <div>
          <div className="text-[10px] tracking-widest uppercase text-[#5C5A57]">Meta venda</div>
          <div className="font-display text-lg font-bold tabular">{brl(g.required_volume)}</div>
        </div>
        <div>
          <div className="text-[10px] tracking-widest uppercase text-[#5C5A57]">Por dia</div>
          <div className="font-display text-lg font-bold tabular" data-testid="needed-per-day">{brl(progress.needed_per_day)}</div>
        </div>
      </div>
    </div>
  );
}
